import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators,AbstractControl,ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PaymentService } from 'src/app/services/payment.service';

declare var jQuery: any

@Component({
  selector: 'app-student-observation',
  templateUrl: './student-observation.component.html',
  styleUrls: ['./student-observation.component.scss']
})
export class StudentObservationComponent implements OnInit {
  totalAmount: any;
  paymentMade: any;
  remainingAmount: any;
  paymentStatus: boolean = false;

  constructor(private paymentService: PaymentService, private spinner: NgxSpinnerService, private activatedRoute: ActivatedRoute
    , private router: Router, private appointmentService: AppointmentService,
    private auth: AuthenticationService, private formBuilder: FormBuilder) { }

  userRole: any
  action!: any
  apptId: any
  comments: string = ""
  apptDetails: any;
  show: boolean = false;
  draftObservation: boolean = false;
  studentInfo!: FormGroup
  studentObservationTest!: FormGroup
  studentObservation!: FormGroup
  paymentModal: boolean = false;
  // paymentAmount
  scheduleId: any
  paymentAmount: any;
  documents: any = [];
  testSurveyComment: string = "";
  appBaseUrl = environment.appBaseUrl;

  // closeModal() {
  //   this.paymentModal = true
  //   if (this.paymentAmount == true) {
  //     this.submitPayment()
  //   }

  // }
  submitPayment() {
    this.spinner.show();
    this.paymentService.addPaymentDetails(this.apptId, this.paymentAmount, null, null).subscribe(res => {
      setTimeout(() => {
        this.spinner.hide()



      });
    })
  }
  ngOnInit(): void {
    this.draftObservation = false;
    this.spinner.show()
    this.activatedRoute.params.subscribe(params => {
      this.apptId = params['id']
      console.log("params['draft']",params['draft'])
      this.draftObservation = params['draft']
    });
    this.show = false


    this.appointmentService.getAppointments(null, null, null, this.apptId, null, null).subscribe(res => {
      if (res.data.length > 0) {
        this.apptDetails = res.data[0];
        this.scheduleId = this.apptDetails.appointmentDetails.schedules[0].scheduleId;
        this.testSurveyComment = this.apptDetails.appointmentDetails.schedules[0].testSurveyComment;
        if (!this.testSurveyComment) {
          this.testSurveyComment = "";
        }

        this.paymentService.getPaymentDetails(this.apptId, null, null).subscribe(res => {
          let details = res.data[0]
          if (details.message != "") {
            this.paymentStatus = true
          }
          else {
            jQuery('#paymentModal').modal('show');

            this.totalAmount = details.totalAmount
            this.paymentMade = details.amount
            this.remainingAmount = details.remaing
            this.paymentStatus = false
          }

          this.appointmentService.getDocument(this.apptId).subscribe(res => {
            res.data.forEach((doc: any) => {
              this.documents.push(doc)
            });
            this.show = true;
            this.spinner.hide()

          })

        })

      }
    });


    this.studentObservationTest = this.formBuilder.group({
      bouncingLeg: [false],
      tappingPencil: [false],
      playingWithPencil: [false],
      pickingIPad: [false],
      upPermission: [false],
      difficultySitting: [false],
      chewingClothing: [false],
      playingWithHair: [false],
      playingWithJewelry: [false],
      shufflingFeet: [false],
      noisesWithMouth: [false],
      humming: [false],
      clickingOfTongue: [false],
      impulsiveResponses: [false],
      excessiveTalking: [false],
      rushesThroughTasks: [false],
      playingWithClothes: [false],
      needsFrequentRedirect: [false]
    });
    this.studentObservation = this.formBuilder.group({
      pencilGrasp: ['', Validators.required],
      holdsPaper: ['', Validators.required],
      moreSnackBreak: ['', Validators.required],
      moreBathroomBreak: ['', Validators.required],
      idk: ['', Validators.required],
      giveUp: ['', Validators.required],
      howMuchLongerTally: ['', Validators.required],
      needsDirection: ['', Validators.required],
      glasses: ['', Validators.required],

    });
    this.studentInfo = this.formBuilder.group({
      answer1: ['', Validators.required],
      answer2: ['', Validators.required],
      answer3: ['', Validators.required],
      answer4: ['', Validators.required],
      answer5: ['', Validators.required],
      answer6: ['', Validators.required]
    });

    console.log(this.draftObservation);
    // someAsyncOperation().then(() => {
    if (this.draftObservation) {
      this.appointmentService.getObservationForm(this.apptId).subscribe(res => {
        //  this.observationForm = res.data
        if (res.code == '200') {
          this.comments = res.data.comments == null ? "" : res.data.comments;
          if ( res.data.studentObservation) {
          this.studentObservation.setValue({
            pencilGrasp: res.data.studentObservation.pencilGrasp,
            holdsPaper: res.data.studentObservation.holdsPaper,
            moreSnackBreak: res.data.studentObservation.moreSnackBreak,
            moreBathroomBreak: res.data.studentObservation.moreBathroomBreak,
            idk: res.data.studentObservation.idk,
            giveUp: res.data.studentObservation.giveUp,
            howMuchLongerTally: res.data.studentObservation.howMuchLongerTally,
            needsDirection: res.data.studentObservation.needsDirection,
            glasses: res.data.studentObservation.glasses,
          });
        }
        if ( res.data.studentObservationTest) {
          this.studentObservationTest.setValue({
            bouncingLeg: res.data.studentObservationTest.bouncingLeg,
            tappingPencil: res.data.studentObservationTest.tappingPencil,
            playingWithPencil: res.data.studentObservationTest.playingWithPencil,
            pickingIPad: res.data.studentObservationTest.pickingIPad,
            upPermission: res.data.studentObservationTest.upPermission,
            difficultySitting: res.data.studentObservationTest.difficultySitting,
            chewingClothing: res.data.studentObservationTest.chewingClothing,
            playingWithHair: res.data.studentObservationTest.playingWithHair,
            playingWithJewelry: res.data.studentObservationTest.playingWithJewelry,
            shufflingFeet: res.data.studentObservationTest.shufflingFeet,
            noisesWithMouth: res.data.studentObservationTest.noisesWithMouth,
            humming: res.data.studentObservationTest.humming,
            clickingOfTongue: res.data.studentObservationTest.clickingOfTongue,
            impulsiveResponses: res.data.studentObservationTest.impulsiveResponses,
            excessiveTalking: res.data.studentObservationTest.excessiveTalking,
            rushesThroughTasks: res.data.studentObservationTest.rushesThroughTasks,
            playingWithClothes: res.data.studentObservationTest.playingWithClothes,
            needsFrequentRedirect: res.data.studentObservationTest.needsFrequentRedirect
          });
        }
        if ( res.data.studentInfo) {
          this.studentInfo.setValue({
            answer1: res.data.studentInfo.answer1,
            answer2: res.data.studentInfo.answer2,
            answer3: res.data.studentInfo.answer3,
            answer4: res.data.studentInfo.answer4,
            answer5: res.data.studentInfo.answer5,
            answer6: res.data.studentInfo.answer6
          });
        }
        }
      });
    }
  }

 validatePayment(){
  const numericPaymentAmount = Number(this.paymentAmount);
  console.log("numeric "+numericPaymentAmount);
  if(isNaN(numericPaymentAmount)){
    return false;
  }else  if(numericPaymentAmount ===0){
    return false;
  }
  else if(numericPaymentAmount  > this.remainingAmount){
    return false
  } else {
    return true;
  }
}



  draftSubmitAppt() {
    this.spinner.show();
    let studentObservationDetails: any = {};
    studentObservationDetails['studentObservationTest'] = this.studentObservationTest.value;
    studentObservationDetails['studentObservation'] = this.studentObservation.value;
    studentObservationDetails['appointmentId'] = this.apptId;
    studentObservationDetails['comments'] = this.comments;
    studentObservationDetails['draftSave'] = true;


    console.log(this.studentInfo.value);
    studentObservationDetails['studentInfo'] = this.studentInfo.value;

    this.appointmentService.submitObservationForm(studentObservationDetails).subscribe((res: any) => {
      if (res.code == '200') {
        this.spinner.hide();
        // let action = "ASSESMENT"
        // this.appointmentService.updateAppts(action, this.apptId, "", this.scheduleId).subscribe(res => {
        this.router.navigate(['/upcoming'])
        // });
      } else {
        this.spinner.hide();
        return;
      }
    })


  }

  noWhitespace(control: AbstractControl): ValidationErrors | null {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }

  completeButtonAction(){
    Object.values(this.studentObservation.controls).forEach(control => {
      control.markAsTouched();
    });
    Object.values(this.studentInfo.controls).forEach(control => {
      control.markAsTouched();
    });
   
    if (this.studentObservation.valid && this.studentInfo.valid) {
       jQuery("#completeApointmentModal").modal('show');
    }
  }
  finalSubmitAppt() {
    this.spinner.show();
    let studentObservationDetails: any = {};
    studentObservationDetails['studentObservationTest'] = this.studentObservationTest.value;
    studentObservationDetails['studentObservation'] = this.studentObservation.value;
    studentObservationDetails['appointmentId'] = this.apptId;
    studentObservationDetails['comments'] = this.comments;
    studentObservationDetails['draftSave'] = false;



    studentObservationDetails['studentInfo'] = this.studentInfo.value;

    this.appointmentService.submitObservationForm(studentObservationDetails).subscribe((res: any) => {
      if (res.code == '200') {
        let action = "ASSESMENT"
        this.appointmentService.updateAppts(action, this.apptId, "", this.scheduleId).subscribe(res => {
          this.router.navigate(['/upcoming'])
        });
      } else {
        this.spinner.hide();
        return;
      }
    })


  }

  get sf() { return this.studentInfo.controls; }

}
